import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card2, Dialog2, Table } from '@dossierhq/design';
import { useContext } from 'react';
import { DossierContext } from '../../contexts/DossierContext.js';
import { filterTypeSpecifications, } from '../../utils/TypeSelectionUtils.js';
export function AdminTypePickerDialog({ title, onItemClick, ...filter }) {
    const { schema } = useContext(DossierContext);
    let items = [];
    if (schema) {
        items = filterTypeSpecifications(schema, filter).map((it) => ({ id: it.name, name: it.name }));
    }
    return (_jsx(Dialog2, { width: "narrow", children: ({ close }) => (_jsxs(Card2, { children: [_jsxs(Card2.Header, { children: [_jsx(Card2.HeaderTitle, { children: title }), _jsx(Card2.HeaderIconButton, { icon: "close", onClick: close })] }), _jsx(Card2.Content, { noPadding: true, children: _jsx(Table, { hoverable: true, children: _jsx(Table.Body, { children: items.map((item) => (_jsx(Table.Row, { clickable: true, onClick: () => onItemClick(item.id), children: _jsx(Table.Cell, { children: item.name }) }, item.id))) }) }) })] })) }));
}
//# sourceMappingURL=AdminTypePickerDialog.js.map